import React from 'react';
import styles from './UserInsightsStatistics.module.scss';
import MessagesPerConversation from './messages-per-conversation/MessagesPerConversation';
import Engagement from './engagemenet/Engagement';
import ConversationLength from './conversation-length/ConversationLength';

const UserInsightsStatistics = ({ startDate, endDate, botId }) => {
  return (
    <div className={styles['user-insights-statistics-container']}>
      <div className={styles['messages-engagement-container']}>
        <MessagesPerConversation
          startDate={startDate}
          endDate={endDate}
          botId={botId}
        />
        <Engagement startDate={startDate} endDate={endDate} botId={botId} />
      </div>
      <ConversationLength
        startDate={startDate}
        endDate={endDate}
        botId={botId}
      />
    </div>
  );
};

export default UserInsightsStatistics;
